import {Injectable} from '@angular/core'
import {HttpClient, HttpContext} from '@angular/common/http'
import {SKIP_ERROR_INTERCEPTOR} from '../app/interceptors/error.interceptor'
import {environment} from '../environments/environment'
import {Wallet} from '../models/wallet';
import {Subject} from 'rxjs';

const API = environment.API

@Injectable({
  providedIn: 'root'
})
export class WalletService {
  refresh$ = new Subject<any>();

  constructor(private http: HttpClient) {
  }

  createStripeCustomerWallet(email: string, description: string, cardToken: string) {
    const body = {email, description, cardToken}
    return this.http.post<Wallet>(`${API}/api/wallets/stripe/customer`, body)
  }

  createBraintreeCustomerWallet(nonce: string) {
    const body = {nonce}
    return this.http.post<Wallet>(`${API}/api/wallets/braintree/customer`, body)
  }

  createInvoiceCustomerWallet(email: string) {
    const body = {email}
    return this.http.post<Wallet>(`${API}/api/wallets/invoice/customer`, body)
  }

  createStripeCompanyWallet(companyId: string, email: string, description: string, cardToken: string) {
    const body = {companyId, email, description, cardToken}
    return this.http.post<Wallet>(`${API}/api/wallets/stripe/company`, body)
  }

  createBraintreeCompanyWallet(companyId: string, nonce: string) {
    const body = {companyId, nonce}
    return this.http.post<Wallet>(`${API}/api/wallets/braintree/company`, body)
  }

  createInvoiceCompanyWallet(companyId: string, email: string) {
    const body = {companyId, email}
    return this.http.post<Wallet>(`${API}/api/wallets/invoice/company`, body)
  }

  setDefault(walletId: string) {
    return this.http.put(`${API}/api/wallets/${walletId}/default`, {})
  }

  findByUser() {
    return this.http.get<Wallet[]>(`${API}/api/wallets/user`, {
      context: new HttpContext().set(SKIP_ERROR_INTERCEPTOR, true)
    })
  }

  findByUserId(userId: string, allowDeactivated: boolean, allowFingerprintMatches: boolean) {
    const params = {allowDeactivated, allowFingerprintMatches}
    const context = new HttpContext().set(SKIP_ERROR_INTERCEPTOR, true)
    return this.http.get<Wallet[]>(`${API}/api/wallets/user/${userId}`, {params, context})
  }

  findByCompanyId(companyId: string, limit = 1000, skip = 0) {
    const params = {limit, skip}
    const context = new HttpContext().set(SKIP_ERROR_INTERCEPTOR, true)
    return this.http.get<Wallet[]>(`${API}/api/wallets/company/${companyId}`, {params, context})
  }

  search(search: string, limit: number, skip: number) {
    const params = {search, limit, skip}
    return this.http.get(`${API}/api/wallets/search`, {params})
  }

  fail(walletId: string) {
    return this.http.put(`${API}/api/wallets/${walletId}/fail`, {})
  }

  failAuthorization(walletId: string, userId: string) {
    const body = {userId}
    return this.http.put(`${API}/api/wallets/${walletId}/failauthorization`, body)
  }

  deactivate(walletId: string) {
    return this.http.put(`${API}/api/wallets/${walletId}/deactivate`, {})
  }

  generateBraintreeClientToken() {
    return this.http.get<{token: string}>(`${API}/api/wallets/braintree/token`)
  }

  generateStripePublishableKey() {
    return this.http.get<{key: string}>(`${API}/api/wallets/stripe/key`)
  }

  block(walletId: string) {
    return this.http.put(`${API}/api/wallets/${walletId}/block`, {})
  }

}
